//Built-in libraries
import { useState } from 'react';

//Custom components
import Table from 'components/UI/Table';

//Services

//Assets and Miscellaneous
import { CurrencyFormatDisplay } from 'components/UI/NumberFormatDisplay/CurrencyFormatDisplay';
import Card from 'components/UI/Card';
import Button from 'components/UI/Button';

const impactByCountyWidgetData = [
  {
    id: 1,
    countyCode: '1',
    countyName: 'Allegany',
    totalGrants: 3355534,
    totalProjects: 19,
  },
  {
    id: 2,
    countyCode: '2',
    countyName: 'Anne Arundel ',
    totalGrants: 4556732,
    totalProjects: 10,
  },
  {
    id: 3,
    countyCode: '3',
    countyName: 'Baltimore City',
    totalGrants: 8567733,
    totalProjects: 13,
  },
  {
    id: 4,
    countyCode: '4',
    countyName: 'Baltimore',
    totalGrants: 8507700,
    totalProjects: 23,
  },
  {
    id: 5,
    countyCode: '5',
    countyName: 'Caroline',
    totalGrants: 6080713,
    totalProjects: 8,
  },
  {
    id: 6,
    countyCode: '6',
    countyName: 'Howard',
    totalGrants: 4556773,
    totalProjects: 9,
  },
  {
    id: 7,
    countyCode: '7',
    countyName: 'Cecil',
    totalGrants: 1006773,
    totalProjects: 6,
  },
];

const ImpactByCountyWidget = () => {
  const [perPage, setPerPage] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);

  const nextPageHandler = () => {
    setPage((prevState) => (prevState === totalPage ? totalPage : page + 1));
  };

  const previousPageHandler = () => {
    setPage((prevState) => (prevState > 1 ? page - 1 : 1));
  };

  const tableColumns = [
    {
      id: 'countyCode',
      Header: 'County Code',
      accessor: 'countyCode',
      Cell: (row: any) => {
        if (row.value.trim() === '') {
          return 'Unknown';
        }
        return row.value;
      },
    },
    {
      id: 'countyName',
      Header: () => <div className='text-center'>County Name</div>,
      accessor: 'countyName',
      Cell: (row: any) => (
        <div className='text-center'>
          <span>{row.value}</span>
        </div>
      ),
    },
    {
      id: 'totalGrants',
      Header: () => <div className='text-center'>Total Grants</div>,
      accessor: 'totalGrants',
      Cell: (row: any) => (
        <div className='text-center'>
          <CurrencyFormatDisplay value={row.value} prefix='$' />
        </div>
      ),
    },
    {
      id: 'totalProjects',
      Header: () => <div className='text-center'>Total Projects</div>,
      accessor: 'totalProjects',
      Cell: (row: any) => (
        <div className='text-center'>
          <span>{row.value}</span>
        </div>
      ),
    },
  ];

  const tablePagination = {
    page: page,
    pageSize: perPage,
    pageCount: totalPage,
    currentPage: page,
    setPageSize: (v: number) => setPerPage(v),
    nextPage: nextPageHandler,
    previousPage: previousPageHandler,
  };

  return (
    <>
      <Card
        title='Impact By County'
        titleElement={
          <div className='flex justify-center gap-2'>
            <Button label='Map View' btnStyle='btn-neutral' btnType='button' />
            <Button label='List View' btnStyle='btn-primary' btnType='button' />
          </div>
        }
      >
        {impactByCountyWidgetData && (
          <div className='h-full w-full'>
            <div className='h-96 border rounded-b-md w-full'>
              <Table
                cols={tableColumns}
                tableData={impactByCountyWidgetData}
                pagination={tablePagination}
                height='h-5/6'
              />
            </div>
          </div>
        )}
      </Card>
    </>
  );
};

export default ImpactByCountyWidget;
